import { render, staticRenderFns } from "./block_links.vue?vue&type=template&id=cb2a5184"
import script from "./block_links.vue?vue&type=script&lang=js"
export * from "./block_links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports